export default "__VITE_ASSET__9ec622c5__"